var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDumbbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.645 -0.645 18 18",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8.355h8.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5.5v5.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 5.5v5.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6 6.8v3.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1 6.8v3.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDumbbell);
export default __webpack_public_path__ + "static/media/dumbbell.3b869342349cc289fef7de3857e74a82.svg";
export { ForwardRef as ReactComponent };